import React, {useEffect, useState} from "react";
import axios from "axios";
import {Button, Col, Row} from "react-bootstrap";
import TextArea from "../../../common/TextArea";
import Input from "../../../common/Input";
import DateBox from "../../../primer/DateBox";
import EditableTable from '../../../primer/Editable-Table';
import Dropdown from "../../../primer/Dropdown";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import {setEditing} from "../../../../_reducers/activitySlice";
import {fetchAdvancedTypes, fetchInitialClients} from "../../../../_apis/api";
import {
  getDefaultOptionByValue,
  getGreekCurrencyFormat,
  getLastHighestPrefixNumber,
  getModeByInstallation,
  getNumberByInstallation,
  getOptionsByData,
  getPreNumberByInstallation,
  getSelectedInstallation,
  getSelectedPreNumbers,
  removeDuplicateObjects
} from "../../../../_helpers/commonFunctions";
import {
  getLabelByValue,
  getObjectFromArrayOfObjects
} from "../../../../_helpers/helperFunctions";
import {setNewClientMovements} from "../../../../_reducers/DataPanel/Clients/clientSlice";
import {preNumberGreek} from "../../../../_data/settings/advanced-types-search";
import {useTranslation} from "../../../../hooks/useTranslation";

const ClientMovementsNew = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const ACTIVITY = useSelector( (state) => state.ACTIVITY );
  const CLIENTS_DATA = useSelector( (state) => state.CLIENTS_DATA );
  const SETTINGS = useSelector( (state) => state.SETTINGS );
  const company = useSelector(state => state.COMPANY_DATA.company)

  const [incrKey, setIncrKey] = useState(0);
  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    if(firstLoad) {
      setFirstLoad(false);
      dispatch(fetchInitialClients(requestData));
      dispatch(fetchAdvancedTypes(requestData));
    }
  }, [firstLoad])

  useEffect(() => {
    const clientAmountSum = getSumOfDataValues(CLIENTS_DATA.newClientMovements.clients, 'amount');
    dispatch(setNewClientMovements({...CLIENTS_DATA.newClientMovements, sum: clientAmountSum}));
  }, [])

  useEffect(() => {
    setIncrKey(incrKey + 1);
  }, [CLIENTS_DATA.newClientMovements.clients, CLIENTS_DATA.clients])

  useEffect(() => {
    if(CLIENTS_DATA.newClientMovements.installation !== undefined && CLIENTS_DATA.newClientMovements.installation !== ''){
      let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData['documentNumbering'], preNumberGreek, CLIENTS_DATA.newClientMovements.installation);
      setPreNumberGreekOptions(newPreNumbers);
    }
  }, []);

  const clientCodeColumns = [
    {
      label: t('ClientsMovementsNew.code'),
      name: "systemCode",
    },
    {
      label: t('ClientsMovementsNew.name'),
      name: "name",
    },
  ];

  const clientMovementColumns = [
    {
      name: "No",
      field: "no",
      editable: false,
    },
    {
      name: t("ClientsMovementsNew.clientCode"),
      field: "systemCode",
      editable: true,
      inputType: {
        config: {
          excludeColumns: [],
          columns: clientCodeColumns,
          data: CLIENTS_DATA.clients,
          deleteEnable: false,
          searchTableEnable: false,
          showTableOptionOnSelect: true,
          placeholder: t("ClientsMovementsNew.placeholder1")
        },
        type: 'advanced-combobox',
      }
    },
    {
      name: t("ClientsMovementsNew.clientName"),
      field: "name",
      editable: true,
      inputType: {
        config: {
          excludeColumns: [],
          columns: clientCodeColumns,
          data: CLIENTS_DATA.clients,
          deleteEnable: false,
          searchTableEnable: false,
          showTableOptionOnSelect: true,
          placeholder: t("ClientsMovementsNew.placeholder2")
        },
        type: 'advanced-combobox',
      }
    },
    {
      name: t("ClientsMovementsNew.amount"),
      field: 'amount',
      editable: true,
      inputType: {
        type: 'accounting',
        config: {
          suffix: "nosuffix",
          maxLength: 10,
          allowNegative: true,
        }
      }
    },
  ];

  // Options for Document Type Dropdown
  const allDocumentTypes = SETTINGS.settings.advancedTypes;
  const clientMovemnetDT = getObjectFromArrayOfObjects(allDocumentTypes, 'Client Movements', 'section');
  const documentTypesOptions =  getOptionsByData(clientMovemnetDT, '_id', 'name')

  const requestData = {
    company:company.id,
    year:company.year.toString(),
  }
  const [preNumberGreekOptions, setPreNumberGreekOptions] = useState([]);
  let selectedDocumentTypeData = [];
  let dtInstallationsOptions = [];
  let disabledFields = false;
  if (CLIENTS_DATA.newClientMovements.documentType === undefined || CLIENTS_DATA.newClientMovements.documentType === '') {
    disabledFields = true;
  } else {
    let dtData = getObjectFromArrayOfObjects(clientMovemnetDT, CLIENTS_DATA.newClientMovements.documentType, '_id');
    if (dtData.length > 0) {
      selectedDocumentTypeData  = dtData['0'];
      dtInstallationsOptions = getOptionsByData(selectedDocumentTypeData['documentNumbering'], "installationMasterId", "installation");
      dtInstallationsOptions = removeDuplicateObjects(dtInstallationsOptions, 'value');
    }
  }


  const handleOnChange = async (e, type="default", ddname = '') => {
    // Set if editing the form
    if (!ACTIVITY.editing) {
      dispatch(setEditing(true));
    }
    let name;
    let value;
    if (type === 'dd' || type === 'ac' ) {
      value = e.value;
      name = ddname;
    } else if (type === 'dp' ) {
      value = e;
      name = ddname;
    } else {
      value = e.target.value;
      name = e.target.name;
    }
    let clientData = Object.assign({}, CLIENTS_DATA);
    let newClientMovementData = {};
    newClientMovementData[name] = value;
    if (name === 'documentType') {
      newClientMovementData.documentTypeName = getLabelByValue(documentTypesOptions, value, 'value');
      let dtData = getObjectFromArrayOfObjects(clientMovemnetDT, value, '_id');
      if (dtData.length > 0) {
        selectedDocumentTypeData  = dtData['0'];
        let selectedInstallation = getSelectedInstallation(selectedDocumentTypeData['documentNumbering']);
        // Selected Installation Fields on Document Type Select
        if (Object.keys(selectedInstallation).length > 0) {
          newClientMovementData.installation = selectedInstallation.installationMasterId;
          newClientMovementData.preNumber = selectedInstallation.preNumber;
          // Logic For Higest Number
          let installationNumber = selectedInstallation.number + 1;
          let lastHigestNumber = getLastHighestPrefixNumber(CLIENTS_DATA.clientMovements, 'number', selectedInstallation.preNumber);
          if (installationNumber > lastHigestNumber) {
            newClientMovementData.number = installationNumber;
          } else {
            newClientMovementData.number = lastHigestNumber + 1;
          }
          newClientMovementData.installationMode = selectedInstallation.installationMode;
        } else {
          newClientMovementData.installation = "";
          newClientMovementData.preNumber = "";
          newClientMovementData.number = "";
          newClientMovementData.installationMode = "";
        }
        // This will pre number given in document number table
        let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData['documentNumbering'], preNumberGreek);
        setPreNumberGreekOptions(newPreNumbers);
      }
    }
    // Update Installation Field Values on Change
    if (name === 'installation') {
      newClientMovementData.installationName = getLabelByValue(dtInstallationsOptions, value, 'value');
      newClientMovementData.preNumber = getPreNumberByInstallation(selectedDocumentTypeData['documentNumbering'], value , 'installation');
      let installationNumber = getNumberByInstallation(selectedDocumentTypeData['documentNumbering'], value , 'installation')
      let lastHigestNumber = getLastHighestPrefixNumber(CLIENTS_DATA.clientMovements, 'number', newClientMovementData.preNumber);
      if (installationNumber > lastHigestNumber) {
        newClientMovementData.number = installationNumber;
      } else {
        newClientMovementData.number = lastHigestNumber + 1;
      }
      // This will pre number given in document number table
      let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData['documentNumbering'], preNumberGreek);
      setPreNumberGreekOptions(newPreNumbers);
      newClientMovementData.installationMode = getModeByInstallation(selectedDocumentTypeData['documentNumbering'], value , 'installation');
    }

    // It will update the last available number from the API.
    if ((name === 'documentType' || name === 'preNumber' || name === 'installation') &&
        (
          (clientData.newClientMovements.installationMode ==='automatic' || newClientMovementData.installationMode ==='automatic' ) &&
          (clientData.newClientMovements.documentType !=='' || newClientMovementData.documentType !=='') &&
          (clientData.newClientMovements.preNumber !=='' || newClientMovementData.preNumber !=='') &&
          (clientData.newClientMovements.installation !=='' || newClientMovementData.installation !==''))) {
      let checkAtParams = {};
      checkAtParams.id            = !newClientMovementData.documentType ? clientData.newClientMovements.documentType : newClientMovementData.documentType;
      checkAtParams.preNumber     = !newClientMovementData.preNumber ? clientData.newClientMovements.preNumber : newClientMovementData.preNumber;
      checkAtParams.installation  = !newClientMovementData.installation.toString() ? clientData.newClientMovements.installation.toString() : newClientMovementData.installation.toString();

      await axios.post(process.env.REACT_APP_API_URL2 + `/settings/add-setting-advance-type-check`, checkAtParams, { headers: { 'Content-Type': 'application/json'}})
      .then(res => {
        if (res.data &&  res.data.status === '200') {
          if (res.data.number !== undefined) {
            newClientMovementData.number = parseInt(res.data.number) + 1;
          }
        }
      }).catch((err) => {
        console.log(err);
      })
    }
    // Save sum on change
    newClientMovementData.sum = getSumOfDataValues(CLIENTS_DATA.newClientMovements.clients, 'amount');
    dispatch(setNewClientMovements({...clientData.newClientMovements, ...newClientMovementData}));
  }

  const getSumOfDataValues = (data, field = 'sum') => {
    let sum = 0;
    if (data && data.length > 0) {
      data.forEach(item => {
        sum += +item[field] || 0;
      })
    }
    return +Number(sum).toFixed(2);
  }

  const parentMydataActions = {
    insert: (e, data) => {
      if (!ACTIVITY.editing) dispatch(setEditing(true));
      const newClient = e.row;
      if(newClient) {
        let movementClients = [...CLIENTS_DATA.newClientMovements.clients];
        if(movementClients.findIndex((el) => el.clientId === newClient._id) !== -1) {
          toast.error("This client is already selected.");
        } else {
          movementClients.push({
            no: String(movementClients.length + 1),
            id: String(movementClients.length + 1),
            systemCode: newClient.systemCode,
            clientId: newClient._id,
            name: newClient.name,
          });
          dispatch(setNewClientMovements({...CLIENTS_DATA.newClientMovements, clients: movementClients, sum: getSumOfDataValues(movementClients, 'amount')}));
        }
      }
    },
    update: (data, id, e) => {
      if (!ACTIVITY.editing) dispatch(setEditing(true));
      const newClient = e.row;
      if(newClient || data) {
        let movementClients = [...CLIENTS_DATA.newClientMovements.clients];
        movementClients = movementClients.map((a) => Object.assign({}, a));
        let idx = movementClients.findIndex((el) => String(el.id) === String(id));
        if (idx !== -1) {
          if(data.clientId || data.name || data.systemCode) {
            if(movementClients.findIndex((el) => el.clientId === newClient._id) !== -1) {
              toast.error("This client is already selected.");
            } else {
              movementClients[idx].clientId = newClient._id;
              movementClients[idx].name = newClient.name;
              movementClients[idx].systemCode = newClient.systemCode;
            }
          }
          if(data.amount) movementClients[idx].amount = data.amount;
        }
        dispatch(setNewClientMovements({...CLIENTS_DATA.newClientMovements, clients: movementClients, sum: getSumOfDataValues(movementClients, 'amount')}));
      }
    },
    selected: () => {},
    delete: (id, rowIndex) => {
      if (!ACTIVITY.editing) dispatch(setEditing(true));
      let movementClients = [...CLIENTS_DATA.newClientMovements.clients];
      movementClients = movementClients.map((a) => Object.assign({}, a));
      movementClients = movementClients.filter((a) => a.id !== String(rowIndex + 1));
      movementClients.forEach((cl, ind) => {
        cl.no = String(ind + 1);
        cl.id = String(ind + 1);
      })
      dispatch(setNewClientMovements({...CLIENTS_DATA.newClientMovements, clients: movementClients, sum: getSumOfDataValues(movementClients, 'amount')}));
    }
  }
  let amountSum = getSumOfDataValues(CLIENTS_DATA.newClientMovements.clients, 'amount');
  amountSum = parseFloat(amountSum).toFixed(2);

  const selectedDocumentType = getDefaultOptionByValue(documentTypesOptions, CLIENTS_DATA.newClientMovements.documentType, 'value', 'label', 'value');
  const selectedPreNumber = getDefaultOptionByValue(preNumberGreek, CLIENTS_DATA.newClientMovements.preNumber, 'value', 'label', 'value');
  return (
    <React.Fragment>
      <div className="client-form product-form position-relative">
      {disabledFields && <div className="overlay_w">{t('ClientsMovementsNew.message')}</div>}
      <Row>
        <Col sm={12} md={3} className="showWithOverlay">
          <Dropdown
            label={t("ClientsMovementsNew.documentTypes")}
            key = { Math.random() }
            defaultValue = {selectedDocumentType}
            required= {true}
            name="documentType"
            options={documentTypesOptions}
            onChange = {(e) => handleOnChange(e, 'dd', 'documentType')}
          />
        </Col>
        <Col sm={12} md={9} className="text-right ">
          <Button className="disabled" size="small">{t("ClientsMovementsNew.files")}</Button>
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={3}>
          <Dropdown
            label={t("ClientsMovementsNew.installation")}
            name="installation"
            value = {getDefaultOptionByValue(dtInstallationsOptions, CLIENTS_DATA.newClientMovements.installation , 'value', 'label', 'value')}
            enabledValue = {true}
            options={dtInstallationsOptions}
            onChange = {(e) => handleOnChange(e, 'dd', 'installation')}
          />
        </Col>
        <Col sm={12} md={2}>
          <Dropdown
            label={t("ClientsMovementsNew.preNumber")}
            name="preNumber"
            value = {selectedPreNumber}
            enabledValue = {true}
            options={preNumberGreekOptions}
            onChange = {(e) => handleOnChange(e, 'dd', 'preNumber')}
          />
        </Col>
        <Col sm="12" md="3">
          <Input
            className="mb-3 w-100"
            label={t("ClientsMovementsNew.number.number")}
            charLimit = {1000}
            name="number"
            value = {CLIENTS_DATA.newClientMovements.number}
            placeholder={t("ClientsMovementsNew.number.placeholder")}
            onChange = {(e) => handleOnChange(e)}
            disabled={disabledFields || CLIENTS_DATA.newClientMovements.installationMode !== 'manual'}
          />
        </Col>
        <Col sm="12" md="4">
          <DateBox
            classes="w-100 mb-3"
            label={t("ClientsMovementsNew.date")}
            name="date"
            required = {true}
            selected="today"
            onChange = {(e) => handleOnChange(e ,'dp', 'date')}
          />
        </Col>
      </Row>
      <Row>
        <Col sm="12">
          <Input
            className="mb-3 w-100"
            label={t("ClientsMovementsNew.reason.reason")}
            name="reason"
            value = { CLIENTS_DATA.newClientMovements.reason }
            onChange = {(e) => handleOnChange(e)}
            placeholder={t("ClientsMovementsNew.reason.placeholder")}
          />
        </Col>
      </Row>
      <hr className="mb-4" />
      <Row>
      <div className="et-table-ui">
        <EditableTable
          // showErrors={initialValue.mydata && initialValue.mydata.length === 0}
          showErrorMessage="My Data should have at least one row."
          tableName = "Client Movements Clients" // Do not change name
          key={"Client Movements Clients" + incrKey}
          allowActions={true}
          onUpdate={parentMydataActions}
          allowInsertRow="true"
          columns={clientMovementColumns}
          enableNewRowCheckbox = {true}
          data={ CLIENTS_DATA.newClientMovements.clients }
        />
      </div>

        <div className="w-100 my-3">
          <div className="sum d-flex border align-items-center justify-content-between">
            <span className="py-2 px-3 border-right"><strong>{t("ClientsMovementsNew.sum")}</strong></span>
            <span></span>
            <span className="py-2 px-3 border-left"><strong>{getGreekCurrencyFormat(amountSum)}</strong></span>
          </div>
        </div>
      </Row>
      <hr />
      <Row>
        <div style={{ width: "100%" }}>
          <div className="text-muted mb-2"><i>{t("ClientsMovementsNew.movementsNotes.movementsNotes")}</i></div>
          <TextArea
            rows="4"
            placeholder={t("ClientsMovementsNew.movementsNotes.placeholder")}
            name="notes"
            limit="1000"
            value = { CLIENTS_DATA.newClientMovements.notes }
            onChange = {(e) => handleOnChange(e)}
          />
        </div>
      </Row>
      </div>
    </React.Fragment>
  )
}

export default ClientMovementsNew;
